'use strict';
(function($){
    /*
     * Vetology.Ajax widget
     *
     * @description Holds all functions related to ajax calls to the vetology platform
     *
     * @options					See description for each option
     *
     * @method	See description above each method
     */
    $.widget(
        'Vetology.Ajax',
        {
            options: {
            },
            /*
             * Vetology.Ajax._init
             *
             * @description	creates the Vetology.Ajax
             *
             * @return NULL
             *
             */
            _create: function(){
            },
            /*
             * Vetology.Ajax._init
             *
             * @description	Initializes the Vetology.Ajax
             *
             * @return NULL
             *
             */
            _init: function(){
                var o = this;
                o._initEvents();
            },
            /*
             * Vetology.Ajax._initEvents
             *
             * @description	Sets up all the necessary event handlers
             *
             * @return NULL
             *
             */
            _initEvents: function(){

                $('body').on('click', '.make_SH', function(e){
                    e.preventDefault();
                    var el = $(this);
                    $.ajax(
                        {
                            url		: '/admin/clinics/view',
                            method	: 'get',
                            data	: {
                                id		:el.data('id'),
                                cast	: true
                            },
                            success	: function(j){
                                if(j.casted){
                                    if(j.status){
                                        var text='This record is now recognized as: Clinic, change to <a href="#" data-id= '+ j.clinicID +' class="make_SH">Clinic and SH</a>'
                                        el.closest('p').html(text);
                                    }else{
                                        var text='This record is now recognized as: Clinic and SH, change to <a href="#" data-id= ' + j.clinicID + ' class="make_SH">Clinic</a>'
                                        el.closest('p').html(text);
                                    }
                                    $("body").Vetology("vetologyShowDialog", "Success:", "Record successfully converted.", "success");
                                } else {
                                    $("body").Vetology("vetologyShowDialog", "Error:", j.message, "error");
                                }
                            },
                            dataType: 'JSON'
                        }
                    );
                });
            },
            /*
             * @description Public function to use the _ping functionality
             * @param url
             * @param pingCallBack
             */
            checkReachabilityUrl: function(url, pingCallBack){
                var o =  this;
                o._ping(url, pingCallBack);
            },
            /*
             * @description Check if the url assigned to an image object is reachable
             * @param url
             * @param callback
             * @private
             */
            _ping: function(url, callback) {
                if (!this.inUse) {
                    this.inUse = true;
                    this.callback = callback;
                    this.url = url;
                    var _that = this;
                    this.img = new Image();
                    this.img.onload = function () {
                        _that.inUse = false;
                        _that.callback('responded');

                    };
                    this.img.onerror = function (e) {
                        if (_that.inUse) {
                            _that.inUse = false;
                            _that.callback('responded', e);
                        }
                    };
                    this.img.src = url;
                    this.timer = setTimeout(function () {
                        if (_that.inUse) {
                            _that.inUse = false;
                            _that.callback('timeout');
                        }
                    }, 1500);
                }
            }
        }
    );
})(jQuery);